var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92345 13.1154H7.69268C7.01295 13.1154 6.46191 13.6664 6.46191 14.3462V19.2692C6.46191 19.949 7.01295 20.5 7.69268 20.5H8.92345C9.60319 20.5 10.1542 19.949 10.1542 19.2692V14.3462C10.1542 13.6664 9.60319 13.1154 8.92345 13.1154Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3072 13.1154H15.0765C14.3967 13.1154 13.8457 13.6664 13.8457 14.3462V19.2692C13.8457 19.949 14.3967 20.5 15.0765 20.5H16.3072C16.987 20.5 17.538 19.949 17.538 19.2692V14.3462C17.538 13.6664 16.987 13.1154 16.3072 13.1154Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.5769V12.5C4 10.3783 4.84285 8.34344 6.34315 6.84315C7.84344 5.34285 9.87827 4.5 12 4.5C14.1217 4.5 16.1566 5.34285 17.6569 6.84315C19.1571 8.34344 20 10.3783 20 12.5V15.5769",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSupport;